export const LIST_PAGE_NAME = "KENDRAS";
export const VIEW_DIALOG_NAME = "KENDRA";